import {Record} from "immutable";
import {
    onChartLoad, onChartLoadFail,
    onChartLoadSuccess,
    onInit,
    onInitFail,
    onInitSuccess,
    setFilterDate, setFilterGroup,
    setFilterRestaurant
} from "./actions";



const dashboard = new Record({
    loading: true,
    currentDate: new Date(),
    currentRestaurantId: null,
    currentTotal: {},
    restaurants: [],

    loadingCharts: false,

    chartOrdersCount: {
        labels: [],
        data: [],
    },
    chartSales: {
        labels: [],
        data: [],
    },
    chartTotalSales: {
        labels: [],
        data: [],
    },

    chartGroup: 'daily',
})();

export default (state = dashboard, action) => {
    switch (action.type) {
        case onInit().type:
            return state.set('loading', true);

        case onInitSuccess().type:
            return state.set('loading', false)
                .set('restaurants', action.data.restaurants)
                .set('currentTotal', action.data.total);

        case onInitFail().type:
            return state.set('loading', false);

        case setFilterDate().type:
            return state.set('currentDate', action.date);
        case setFilterRestaurant().type:
            return state.set('currentRestaurantId', action.id);

        case onChartLoad().type:
            return state.set('loadingCharts', true);

        case onChartLoadSuccess().type:
            return state.set('loadingCharts', false)
                .set('chartOrdersCount', action.data.chartOrdersCount)
                .set('chartSales', action.data.chartSales)
                .set('chartTotalSales', action.data.chartTotalSales)

        case onChartLoadFail().type:
            return state.set('loadingCharts', false)

        case setFilterGroup().type:
            return state.set('chartGroup', action.group);

        default:
            return state;
    }
}
